<script lang="ts">
  import { AceEditor } from "svelte-ace";
  import "brace/mode/javascript";
  import "brace/theme/chrome";

  export let code: string;

  function onResetCode() {
    if (confirm("Are you sure you want to reset all code?")) {
      code = "";
      location.reload();
    }
  }
</script>

<button class="btn btn-sm btn-secondary" on:click={onResetCode}>Reset</button>
<div class="editor">
  <AceEditor height="100%" lang="javascript" theme="chrome" bind:value={code} />
</div>

<style>
  button {
    margin-bottom: 8px;
  }

  .editor {
    height: 256px;
    resize: vertical;
    overflow: auto;
  }
</style>
